
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[...slug]",
      function () {
        return require("private-next-pages/blog/[...slug]/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[...slug]"])
      });
    }
  